import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Resource from 'vue-resource'
Vue.use(Resource)
Vue.http.headers.common['Access-Control-Allow-Origin'] = 'http://s3.ralphandco.com'

import main from './containers/main'
import dashboard from './containers/dashboard'
import singlearticle from './containers/SingleArticle'
// application routes
const routes = [
  { path: '/', component: main },
  { path: '/dashboard', component: dashboard },
  { path: '/article', component: singlearticle },
  { name: 'single-project', path: '/article/:id', component: singlearticle, props: true },
  { path: '/article/:*', component: dashboard }
]
// export router instance
export default new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'is-active'
})




// WEBPACK FOOTER //
// ./src/router.js